export enum INVESTORS_URL {
  BASE = 'investors',
  CC_TRACKER = 'cc-tracker',
  DISTRIBUTION_TRACKER = 'distribution-tracker'
}
